import React, {memo} from "react";
import {FLEX_CENTER_CENTER} from "../../consts/style";

export default memo(({children}) => {
    return <div style={FLEX_CENTER_CENTER}>
        {children}
    </div>
});
